import moment from "moment/moment";
import { formatDate } from "../../../../../../../../../../../../utils/helpers/date-time/datetime-format";
import {
  BudgetPeriod,
  BudgetType,
} from "../../../../../../../../../../../../services/cloudchipr.api";

interface GenerateDateLabelByBudgetPeriodArgs {
  startDate?: string;
  endDate?: string;
  period?: BudgetPeriod;
  type?: BudgetType;
}

export const generateDateLabelByBudgetPeriod = ({
  startDate,
  endDate,
  period,
  type = "fixed",
}: GenerateDateLabelByBudgetPeriodArgs) => {
  if (!startDate || !period) {
    return "";
  }

  let date = type === "fixed" ? startDate : moment();

  switch (period) {
    case "monthly": {
      date = formatDate(date, { format: "MMM" });
      break;
    }
    case "daily": {
      date = formatDate(date, { type: "dayMonthName" });
      break;
    }
    case "annually": {
      date = `${moment(date).get("year")}`;
      break;
    }
    case "quarterly": {
      date = `Q${moment(date).quarter()}`;
      break;
    }
    case "custom": {
      if (endDate) {
        const startYear = moment(startDate).get("year");
        const endYear = moment(endDate).get("year");
        const isSameYear = startYear === endYear;

        const formattedStartDate = formatDate(startDate, {
          type: isSameYear ? "dayMonthName" : "dateWithComma",
        });
        const formattedEndDate = formatDate(endDate, { type: "dateWithComma" });

        date = `${formattedStartDate} - ${formattedEndDate}`;
      } else {
        date = `${formatDate(startDate, { type: "dateWithComma" })} - No End Date`;
      }
      break;
    }
  }

  return date;
};
